class FacetDrawer extends MainDrawer {
  constructor() {
    super();

    this.trigger = this.querySelector('.drawer__trigger')    
    if(this.trigger){
      this.trigger.addEventListener('click', () => this.loadAssets())
    }
  }        

  loadAssets() {           
    this.openDrawer()
    if(!document.getElementById('FACETSCSS') && !document.getElementById('FACETSJS')){
      this.classList.add('loading')
    }                
    loadCss('facets')
      .then(() => {this.classList.remove('loading')})                                              
      .catch(error => {console.error(error)})      
    loadScript('facets')        
      .catch(error => {console.error(error)})
  }  
}
customElements.define('facet-drawer', FacetDrawer);



(() => {
	console.log('collection js')
	var e = document.querySelector("[data-product-grid]"),
			t = document.querySelectorAll("[data-product]"),
			i = document.querySelectorAll("[data-product-card-form]");

	console.log(`${e}
	 ${t}
	  ${i}`)
	function n(e, t) {
			var i = e.querySelector(".js-button-add-tocart"),
					n = e.querySelector(".js-button-preorder"),
					r = e.querySelector(".js-date-preorder");
			"false" !== t.target.dataset.optionPreorder ? (i.classList.add("is-hidden"), n.classList.remove("is-hidden"), r.classList.remove("is-hidden"), r.querySelector("span").innerHTML = t.target.dataset.optionPreorder, e.elements.preOrder.value = t.target.dataset.optionPreorder) : (i.classList.remove("is-hidden"), n.classList.add("is-hidden"), r.classList.add("is-hidden"), e.elements.preOrder.value = !1)
	}
	e && (document.addEventListener("click", (function(e) {
		console.log(e.currentTarget)
			if (e.target.closest("[data-product-btn]")) {
					for (var i = 0; i < t.length; i++) t[i].classList.remove("is-form-open");
					e.target.closest("[data-product]").classList.add("is-form-open")
			}
			if (!e.target.closest("[data-product]"))
					for (var n = 0; n < t.length; n++) t[n].classList.remove("is-form-open")
	})), i.length > 0 && i.forEach((function(e) {
			"one-option" === e.dataset.productCardForm ? function(e) {
					e.addEventListener("change", (function(t) {
							n(e, t)
					})), e.addEventListener("submit", (function(t) {
							t.preventDefault();
							var i = e.querySelectorAll("[ data-option-input]"),
									n = Array.from(i).find((function(e) {
											return e.checked
									}));
							let preorder = e.elements.preOrder.value;
							console.log('Add to cart')

							addToCart(n.value, preorder);
							//window.addToCart(n.value, 1, !0, r, "false")
					}))
			}(e) : "multiply-options" === e.dataset.productCardForm ? function(e) {
					var t = e.querySelectorAll("[data-option-group]")[0],
							i = e.querySelectorAll("[data-option-group]")[1],
							r = t.querySelectorAll("[ data-option-input]");
					r.forEach((function(t) {
							t.addEventListener("change", (function() {
									! function() {
											var t = Array.from(r).find((function(e) {
															return e.checked
													})),
													n = t.dataset.optionInput,
													a = t.dataset.optionIndex,
													s = JSON.parse(e.dataset.variants),
													o = [],
													l = JSON.parse(e.dataset.metadata);
											s.forEach((function(e) {
													e["".concat(a)] === n && o.push(e)
											})), i.innerHTML = "";
											var c = document.createElement("span");
											c.innerHTML = i.dataset.optionGroup, c.className = "form-card__title", i.append(c);
											var u = o.length + 1,
													d = 0,
													p = "";
											o.forEach((function(e, t) {
													for (var r = "", a = "", s = [], o = !1, c = 0, h = Object.entries(l); c < h.length; c++) {
															var f = eu(h[c], 2),
																	m = f[0],
																	g = f[1];
															o = parseInt(m) === e.id && g
													}
													e.available ? (a = "", p = "", t < u && (r = "checked", u = t)) : (d += 1, a = "disabled", r = "", p = "<span> - Sold out </span>"), e.options.forEach((function(e) {
															e !== n && s.push(e)
													}));
													var v = s[s.length - 1],
															y = document.createElement("label");
													y.className = "form-card__label", y.innerHTML = '<input type="radio" \n                    name="'.concat(i.dataset.optionGroup, '"  \n                    class="form-card__input" \n                    ').concat(r, "\n                    ").concat(a, '\n                    value="').concat(e.id, '"\n                    data-option-input="').concat(v, '"\n                    data-option-preorder="').concat(o, '"\n                />\n                <div class="form-card__text"> ').concat(v, " ").concat(p, "</div>"), i.append(y)
											})), d === o.length ? e.querySelector(".form-card__btn").setAttribute("disabled", "disabled") : e.querySelector(".form-card__btn").removeAttribute("disabled")
									}()
							}))
					})), e.addEventListener("submit", (function(t) {
							t.preventDefault();
							var n = i.querySelectorAll("[ data-option-input]"),
									r = Array.from(n).find((function(e) {
											return e.checked
									}));

							let preorder = e.elements.preOrder.value;
							console.log('Add to cart');

							addToCart(r.value, preorder);
							//window.addToCart(r.value, 1, !0, a, "false")
					})), e.addEventListener("change", (function(t) {
							n(e, t)
					}))
			}(e) : console.log("other-options")
	})))

	function addToCart(variantId, preorder){
		let formData;
		if(preorder) {
			formData = {
			'items': [{
				'id': variantId,
				'quantity': 1,
					'properties': {
							'preorder': preorder
					}
				}],
				'sections': "cart-drawer,cart-icon-bubble"
			};
		} else {
			formData = {
			'items': [{
				'id': variantId,
				'quantity': 1
				}],
				'sections': "cart-drawer,cart-icon-bubble"
			};

		}

		fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		})
		.then(response => {
			return response.json();
		})
		.then(response =>{
			const cartDrawer = document.querySelector('cart-drawer');
			cartDrawer.renderContents(response);
		})
		.catch((error) => {
			console.error('Error:', error);
		});
	}
})()